document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.custom_product_splide');

  sliders.forEach(function (splideEl) {
    new Splide(splideEl, {
      type: 'loop',
      perPage: 4,
      gap: '3rem', 
      pagination: false,
      arrows: true,
      breakpoints: {
        1024: {
          perPage: 3,
          gap: '2rem'
        },
        767: {
          perPage: 2,
          gap: '1rem'
        },
        480: {
          perPage: 1,
          gap: '0.5rem'
        }
      }
    }).mount();
  });
});
